export const getAllLanguageFiles = () => {
    return require.context('../../assets/Languages', false, /.json$/);
}

export const getAvailableLanguageCodes = () => {
    return getAllLanguageFiles().keys().map(filename => filename.replace(/\.\/(.*).json$/g, "$1"));
}